<template>
	<div class="app-container">
		<el-row :gutter="20">
			<el-col :md="19" :sm="24">
				<section class="card-node channel-panel">
					<header class="card-header">连接您的渠道</header>
					<div class="card-body">
						<el-row :gutter="15">
							<el-col :span="6" :xs="12" v-for="(item, index) in mainChannels" :key="index">
								<div class="channel-item" :class="{ 'is-active': activeTab === item.id }"
									@click="handleChannelClick(item)" @mouseenter="hoverIdx = index"
									@mouseleave="hoverIdx = null">
									<img :src="item.icon" class="icon" alt="">
									<template v-if="hoverIdx !== index">
										<span class="name">{{ item.name }}</span>
										<span class="status-tag"
											:style="{ color: item.connected ? '#409eff' : '#999' }">
											{{ item.connected ? '已接入' : '未接入' }}
										</span>
									</template>
									<el-button v-else type="primary" size="mini" round @click.stop>接入</el-button>
								</div>
							</el-col>
						</el-row>
					</div>
				</section>

				<section class="card-node guide-panel">
					<header class="card-header flex-between">
						<span>新人指引教程</span>
						<nav class="inner-tabs">
							<span class="active">聊天插件</span>
						</nav>
					</header>
					<div class="card-body">
						<el-collapse v-model="activeCollapse" accordion class="custom-collapse">
							<el-collapse-item v-for="(step, index) in chatGuideSteps" :key="index"
								:title="(index + 1) + '. ' + step.title" :name="String(index + 1)">
								<div class="guide-inner">
									<p>{{ step.desc }}</p>
									<ul class="dot-list">
										<li v-for="point in step.points" :key="point">{{ point }}</li>
									</ul>
									<footer class="footer-actions">
										<el-button type="primary" size="small"
											@click="goToPath(step.path)">{{ step.btn }}</el-button>
										<span class="hint">安装插件有问题？<el-link type="primary"
												:underline="false">咨询客服</el-link></span>
									</footer>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				</section>
			</el-col>

			<el-col :md="5" :sm="24">
				<aside class="card-node user-profile">
					<el-avatar :size="64" :src="userInfo.avatar" icon="el-icon-user-solid" />
					<h4 class="username">{{ userInfo.username || '加载中...' }}</h4>
					<div class="plan-bar">
						<span>当前套餐: <el-tag size="mini" effect="dark">Free版</el-tag></span>
						<el-link type="primary">升级</el-link>
					</div>
				</aside>

				<section class="card-node news-panel">
					<header class="card-header flex-between">
						<span>更新动态</span>
						<time class="date">{{ curDate }}</time>
					</header>
					<div class="card-body">
						<ul class="news-list">
							<li v-for="(news, i) in newsList" :key="i" class="ellipsis clickable"
								@click="showNoticeDetail(news)">
								{{ i + 1 }}. {{ news.title }}
							</li>
						</ul>
					</div>
				</section>
			</el-col>
		</el-row>

		<el-dialog :title="currentNotice.title" :visible.sync="dialogVisible" width="420px"
			custom-class="custom-notice-dialog" append-to-body center>
			<div class="notice-content-wrapper" v-html="currentNotice.content"></div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="small" round @click="dialogVisible = false"
					style="width: 100px;">我知道了</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo: {
					username: '',
					avatar: '',
					channel: null,
				},
				curDate: '',
				activeTab: null,
				activeCollapse: '',
				hoverIdx: null,
				newsList: [], // 现在存储完整的对象数组

				// 弹窗相关
				dialogVisible: false,
				currentNotice: {
					title: '',
					content: ''
				},

				mainChannels: [{
					id: 'chat',
					name: '聊天插件',
					icon: 'https://cdn-icons-png.flaticon.com/512/5968/5968771.png',
					connected: false
				}],

				chatGuideSteps: [
					// ... 保持不变
					{
						title: '添加聊天插件到您的网站',
						desc: '已自动为您创建好聊天插件，您可以：',
						points: ['装修聊天插件样式与风格', '开启访客留资表单，网站引流部件', '复制插件代码，在您的网站代码 </body> 之前插入'],
						btn: '配置插件',
						path: '/home/integrated'
					},
					{
						title: '开始您的第一个会话',
						desc: '熟悉如何与您的客户进行聊天：',
						points: ['插件端支持发送文本/图片/附件内容', '可在【聊天】模块回复访客消息'],
						btn: '模拟会话',
						path: '/home/chat'
					},
					{
						title: '查看你网站上的实时访客',
						desc: '实时管理全部访客，构建客户资产池：',
						points: ['查看访客在线状态，浏览轨迹', '自动筛选有效客户'],
						btn: '前往查看',
						path: '/home/customer/customerList'
					}
				]
			};
		},
		methods: {
			getToday() {
				const now = new Date();
				const year = now.getFullYear();
				const month = String(now.getMonth() + 1).padStart(2, '0');
				const day = String(now.getDate()).padStart(2, '0');
				this.curDate = `${year}-${month}-${day}`;
			},
			async fetchNotices() {
				try {
					const res = await this.$axios.get(this.$apis.getNoticeList);
					if (res.code === 1 && Array.isArray(res.data)) {
						// 修改点：直接存储整个数组，这样就包含了 id, title, content 等
						this.newsList = res.data;
					}
				} catch (error) {
					console.error("获取公告列表失败", error);
				}
			},
			// 新增：打开弹窗的方法
			showNoticeDetail(notice) {
				this.currentNotice = notice;
				this.dialogVisible = true;
			},
			goToPath(path) {
				if (!path) return;
				this.$router.push(path).catch(err => {
					if (err.name !== 'NavigationDuplicated') console.error(err);
				});
			},
			handleChannelClick(item) {
				this.activeTab = item.id;
				this.activeCollapse = item.id === 'chat' ? '1' : '';
			},
			async fetchUserInfo() {
				try {
					const res = await this.$axios.get(this.$apis.getInfo);
					if (res.code === 1) {
						this.userInfo = res.data;
						const isChatConnected = !!(res.data.channel && Object.keys(res.data.channel).length > 0);
						const chatChannel = this.mainChannels.find(c => c.id === 'chat');
						if (chatChannel) chatChannel.connected = isChatConnected;
					}
				} catch (error) {
					console.error("获取用户信息失败", error);
				}
			}
		},
		created() {
			this.getToday();
			this.fetchUserInfo();
			this.fetchNotices();
		}
	};
</script>

<style lang="scss" scoped>
	// ... 保留您原有的样式
	$radius-base: 10px;
	$padding-card: 20px;
	$c-border: #f0f0f0;
	$c-primary: #409eff;
	$c-text: #2c3e50;
	$c-sub: #7f8c8d;

	.app-container {
		background: #f8f9fa;
		padding: 20px;
		color: $c-text;

		.card-node {
			background: #fff;
			border-radius: $radius-base;
			border: 1px solid $c-border;
			margin-bottom: 20px;
			overflow: hidden;

			.card-header {
				padding: 14px $padding-card;
				border-bottom: 1px solid $c-border;
				font-weight: 600;

				&.flex-between {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}
			}

			.card-body {
				padding: $padding-card;
			}
		}

		// 更新动态弹窗深度美化
		::v-deep .custom-notice-dialog {
			border-radius: 12px; // 更圆润的角
			overflow: hidden;
			box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15); // 更柔和的阴影

			.el-dialog__header {
				padding: 20px 20px 10px;
				background: #fff;

				.el-dialog__title {
					font-size: 16px;
					font-weight: 600;
					color: #333;
				}
			}

			.el-dialog__body {
				padding: 10px 25px 20px;
				color: #606266;

				// 限制高度并美化滚动条
				.notice-content-wrapper {
					max-height: 400px;
					overflow-y: auto;
					line-height: 1.8;
					font-size: 14px;
					padding-right: 8px;

					// 自定义滚动条样式
					&::-webkit-scrollbar {
						width: 4px;
					}

					&::-webkit-scrollbar-thumb {
						background: #e0e0e0;
						border-radius: 4px;
					}

					img {
						border-radius: 6px;
						margin: 10px 0;
						max-width: 100%;
						display: block;
					}

					p {
						margin-bottom: 12px;
					}
				}
			}

			.el-dialog__footer {
				padding-bottom: 25px;
				border-top: none; // 去掉页脚分割线更显高级
			}
		}


		.channel-item {
			height: 120px;
			border: 1px solid $c-border;
			border-radius: $radius-base;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			transition: 0.3s;

			&:hover {
				border-color: $c-primary;
				background: #fafafa;
			}

			&.is-active {
				background: #f0f7ff;
				border-color: $c-primary;
			}

			.icon {
				width: 40px;
				margin-bottom: 10px;
			}

			.name {
				font-size: 13px;
				font-weight: 500;
			}

			.status-tag {
				font-size: 11px;
				margin-top: 4px;
			}
		}

		.dot-list {
			padding-left: 20px;

			li {
				line-height: 2.4;
				font-size: 13px;
				color: $c-sub;
				list-style: disc;
			}
		}

		.footer-actions {
			margin-top: 15px;

			.hint {
				margin-left: 15px;
				font-size: 12px;
				color: #999;
			}
		}

		.user-profile {
			padding: 30px 20px;
			text-align: center;

			.username {
				margin: 15px 0;
			}

			.plan-bar {
				background: #fdfdfd;
				padding: 10px;
				border-radius: 6px;
				display: flex;
				justify-content: space-between;
				font-size: 13px;
			}
		}
	}

	::v-deep .custom-collapse {
		border: none;

		.el-collapse-item__header {
			background: #fafafa;
			border: 1px solid $c-border;
			border-radius: 4px;
			padding: 0 15px;
			margin-bottom: 5px;
		}

		.el-collapse-item__wrap {
			border: 1px solid $c-border;
			border-top: none;
			padding: 15px;
			margin-bottom: 10px;
		}
	}

	.news-list li {
		margin-bottom: 12px;
		font-size: 13px;

		// 新增：鼠标手势
		&.clickable {
			cursor: pointer;

			&:hover {
				color: $c-primary;
			}
		}
	}

	.ellipsis {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	// 新增：公告内容样式适配
	.notice-content-wrapper {
		line-height: 1.6;
		font-size: 14px;

		::v-deep img {
			max-width: 100%;
			height: auto;
		}
	}
</style>